// extracted by mini-css-extract-plugin
export default {"skeleton":"skeleton_skeleton__NBogS","skeleton-loading":"skeleton_skeleton-loading__w1uOw","loading":"skeleton_loading__vDxXs"};